import Vue from 'vue';
export var broadcast = new Vue();